// Unlike other files in this directory,
// there is no origin form-builder component for this file;
// this is mere helper functions for the editors.
export const ErrorMessage: React.FC<{ msg: string | undefined }> = ({ msg }) =>
  msg ? <p className="help is-danger">{msg}</p> : null;
